import React from 'react'
import { Link, useParams } from 'react-router-dom'
import { api } from '../../services/api'
import { useContentItem, useContentList } from '../../hooks/useContent'
import { getImageUrl, rewriteHtmlMedia } from '../../utils/imageUrl'
import SidebarWidgets from '../Common/SidebarWidgets'

function formatBlogDate(value) {
    if (!value) return ''
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return String(value).slice(0, 10)
    return date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    })
}

function BlogDetailsMain() {
    const { id } = useParams()
    const { item: blogPost, loading, error } = useContentItem(api.getBlogPost, id)
    const { items: allPosts } = useContentList(() => api.getBlogPosts({ per_page: 8 }), [])

    if (loading) {
        return <div className="container py-5 text-center">Loading blog post...</div>
    }

    if (error || !blogPost) {
        return (
            <section className="th-blog-wrapper blog-details space-top space-extra-bottom">
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-8 col-lg-7">
                            <div className="py-5 text-center text-danger">
                                {error || 'Blog post not found'}
                            </div>
                        </div>
                        <div className="col-xxl-4 col-lg-5">
                            <SidebarWidgets categoryType="blog" showSearch={false} />
                        </div>
                    </div>
                </div>
            </section>
        )
    }

    const published = formatBlogDate(blogPost.published_at)
    const bodyHtml = rewriteHtmlMedia(blogPost.content, 'blog')
    const related = allPosts
        .filter((post) => String(post.id) !== String(blogPost.id))
        .slice(0, 3)

    return (
        <section className="th-blog-wrapper blog-details twa-blog-page space-top space-extra-bottom">
            <div className="container shape-mockup-wrap">
                <div className="row gy-4 align-items-start">
                    <div className="col-xxl-8 col-lg-7">
                        <article className="th-blog blog-single twa-blog-article">
                            {(blogPost.bannerImg || blogPost.image) && (
                                <div className="blog-img twa-blog-hero">
                                    <img
                                        src={getImageUrl(blogPost.bannerImg || blogPost.image, 'blog')}
                                        alt={blogPost.title || 'Blog'}
                                    />
                                </div>
                            )}
                            <div className="blog-content">
                                <div className="blog-meta">
                                    {blogPost.author_name && (
                                        <span className="author">
                                            <i className="fa-light fa-user" />
                                            by {blogPost.author_name}
                                        </span>
                                    )}
                                    {published && (
                                        <span>
                                            <i className="fa-regular fa-calendar" />
                                            {published}
                                        </span>
                                    )}
                                    {blogPost.location && (
                                        <span>
                                            <img src="/assets/img/icon/map.svg" alt="" />
                                            {blogPost.location}
                                        </span>
                                    )}
                                </div>
                                <h1 className="blog-title">{blogPost.title}</h1>
                                {blogPost.excerpt && (
                                    <p className="blog-text twa-blog-excerpt">{blogPost.excerpt}</p>
                                )}
                                {bodyHtml && (
                                    <div
                                        className="twa-blog-body"
                                        dangerouslySetInnerHTML={{ __html: bodyHtml }}
                                    />
                                )}
                                <div className="share-links clearfix">
                                    <div className="row justify-content-between">
                                        <div className="col-md-auto">
                                            <Link to="/blog" className="th-btn style4 th-icon">
                                                Back to Blog
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </article>

                        {related.length > 0 && (
                            <div className="twa-related-posts">
                                <h3 className="twa-related-posts__title">More Stories</h3>
                                <div className="row gy-4">
                                    {related.map((post) => (
                                        <div className="col-md-4" key={post.id}>
                                            <Link to={`/blog/${post.id}`} className="twa-related-card">
                                                {(post.image || post.bannerImg) && (
                                                    <div className="twa-related-card__img">
                                                        <img
                                                            src={getImageUrl(post.image || post.bannerImg, 'blog')}
                                                            alt={post.title || 'Blog'}
                                                        />
                                                    </div>
                                                )}
                                                <h4 className="twa-related-card__title">{post.title}</h4>
                                                {post.published_at && (
                                                    <span className="twa-related-card__date">
                                                        {formatBlogDate(post.published_at)}
                                                    </span>
                                                )}
                                            </Link>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="col-xxl-4 col-lg-5">
                        <div className="twa-blog-sidebar">
                            <SidebarWidgets
                                categoryType="blog"
                                showSearch={false}
                                excludePostId={blogPost.id}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default BlogDetailsMain
